import { MfsStatusCode } from '@metaos/mfs-telemetry';
import { MfsFolderError } from './mfsFolderError';
/**
 * The server cannot or will not process the request due to something that is
 * perceived to be a client error (e.g., malformed request syntax,
 * invalid request message framing, or deceptive request routing).
 * HTTP Response Status Code 400
 *
 * @param message The message that will be returned to the user
 * @param eventName Identification of the event that triggered the error
 */
export class BadRequest extends MfsFolderError {
    constructor(message, eventName) {
        super(message !== null && message !== void 0 ? message : `Bad Request`, false, eventName !== null && eventName !== void 0 ? eventName : 'BadRequest', MfsStatusCode.BadRequest);
    }
}
//# sourceMappingURL=badRequest.js.map